import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseUrl = process.env.REACT_APP_API_URI;
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // const token = getState().userSignIn?.token
      const {
        userSignIn: { userInfo },
        // adminSignIn: { adminInfo },
      } = getState();
      // const {
      //   adminSignIn: { adminInfo },
      // } = getState()
      console.log(
        "tokenapi",

        "userInfo?.token",
        userInfo
      );
      if (userInfo) {
        headers.set("Authorization", `Bearer ${userInfo}`);
      }
      // else if (adminInfo?.adminToken) {
      //   headers.set("Authorization", `Bearer ${adminInfo?.adminToken}`);
      // }
      return headers;
    },
  }),
  tagTypes: ["Pro", "User"],
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (userData) => ({
        url: "/users/sign-up",
        method: "POST",
        body: userData,
      }),
    }),
    loginUser: builder.mutation({
      query: (userData) => ({
        url: "/users/login",
        method: "POST",
        body: userData,
      }),
      invalidatesTags: ["user"],
    }),
    logoutUser: builder.mutation({
      query: () => ({
        url: "/users/logout",
        method: "Delete",
      }),
      invalidatesTags: ["user"],
    }),
    createPostJobApi: builder.mutation({
      query: (data) => ({
        url: "/api/v1/create-post-job",
        method: "POST",

        body: data,
      }),
      invalidatesTags: ["pro"],
    }),
    findJobByCategorysApi: builder.mutation({
      query: (data) => ({
        url: "/api/v1/find-job",
        method: "POST",

        body: data,
      }),
      invalidatesTags: ["pro"],
    }),
    //bussines customer
    createProfileApi: builder.mutation({
      query: (data) => ({
        url: "/users/create/profile",
        method: "POST",

        body: data,
      }),
      invalidatesTags: ["user"],
    }),
    customerSurveyApi: builder.mutation({
      query: (data) => ({
        url: "/api/v1/customer-survey",
        method: "POST",

        body: data,
      }),
      // invalidatesTags: ["user"],
    }),

    findMyJobApi: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: () => `/api/v1/find-my-job`,

      providesTags: ["Pro"],
    }),

    EditJob: builder.mutation({
      query: (data) => ({
        url: "/api/v1/edit-job",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Pro"],
    }),
    DeleteJob: builder.mutation({
      query: (jobId) => ({
        url: `/api/v1/delete-job/${jobId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [{ type: "Pro", id: arg.id }],
    }),

    //paypal route
    CreatedSUB: builder.mutation({
      query: () => ({
        url: "/api/v1/sub/pay",
        method: "POST",
        // body: data,
        mode: "cors",
      }),
      // invalidatesTags: ["Pro"],
    }),

    SuucessPaid: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: () => `/api/v1/sub/success`,
      // providesTags: ["pro"],
    }),
    onCalledPay: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: (categories) => `/api/v1/cancel`,
      // providesTags: ["pro"],
    }),

    //pro
    findJobByCategoryApi: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: (categories) =>
        `/api/v1/find-job/categories?categories=${categories}`,
      providesTags: ["pro"],
    }),
    findJobById: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: (jobId) => `/api/v1/find-my-job/${jobId}`,
      providesTags: ["pro"],
    }),
    findJobRecommendApi: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: () => `/api/v1/find-job/recommended`,
      providesTags: ["pro"],
    }),

    findUserApi: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: () => `/users/find-user`,
      providesTags: ["user"],
    }),
    findJobByZipCodeApi: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: (zip_code) => `/api/v1/find-job/zip_code?zip_code=${zip_code}`,
      providesTags: ["pro"],
    }),
    viewProProfiles: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: (userId) => `/users/get-pro-profile/${userId}`,
      // providesTags: ["pro"],
    }),
    MyProProfiles: builder.query({
      // get: 'http://localhost:8080/api/categories'
      query: () => `/users/get-my-pro-profile`,
      // providesTags: ["pro"],
    }),
    applyLinks: builder.mutation({
      query: (jobId) => ({
        url: "/api/v1/apply-link",
        method: "POST",
        body: jobId,
        // mode: "cors",
      }),
      // invalidatesTags: ["Pro"],
    }),
    passwordRequest: builder.mutation({
      query: (data) => ({
        url: "/users/forget-password-request",
        method: "POST",
        body: data,
        // mode: "cors",
      }),
    }),
    confirmPasswordRequest: builder.mutation({
      query: (data) => ({
        url: "/users/confirm-password-request",
        method: "POST",
        body: data,
        // mode: "cors",
      }),
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useLoginUserMutation,
  useLogoutUserMutation,
  useCreatePostJobApiMutation,
  useFindJobByCategoryApiQuery,
  useFindJobByZipCodeApiQuery,
  useFindJobByCategorysApiMutation,
  useFindJobRecommendApiQuery,
  useCreateProfileApiMutation,
  useFindUserApiQuery,
  useFindJobByIdQuery,
  useFindMyJobApiQuery,
  useEditJobMutation,
  useDeleteJobMutation,
  useCreatedSUBMutation,
  useSuucessPaidQuery,
  useOnCalledPayQuery,
  useApplyLinksMutation,
  useViewProProfilesQuery,
  useCustomerSurveyApiMutation,
  useMyProProfilesQuery,
  usePasswordRequestMutation,
  useConfirmPasswordRequestMutation,
} = apiSlice;
